module.exports = __webpack_public_path__ + "img/product_kitchenl.0b942ebd.jpg";